import Vue from 'vue'
import App from './App.vue'
import './assets/index.css'
import './assets/rem.js'
import Element from 'element-ui'
Vue.config.productionTip = false
Vue.use(Element, {
  size: 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})
new Vue({
  render: h => h(App),
}).$mount('#app')
